const positions = {
  target1: {
    x: [
      120, 240, 340, 440, 540, 640, 740, 840, 940, 1040, 1140, 1120, 1120, 1120,
      1120, 1120, 1120, 1120, 1120, 1120, 1140, 1020, 920, 820, 720, 620, 520,
      420, 320, 220, 120, 140, 140, 140, 140, 140, 140, 140, 140, 140,
    ],
    y: [
      120, 140, 140, 140, 140, 140, 140, 140, 140, 140, 120, 240, 340, 440, 540,
      640, 740, 840, 940, 1040, 1140, 1120, 1120, 1120, 1120, 1120, 1120, 1120,
      1120, 1120, 1140, 1020, 920, 820, 720, 620, 520, 420, 320, 220,
    ],
  },
  target2: {
    x: [
      40, 220, 320, 420, 520, 620, 720, 820, 920, 1020, 1140, 1160, 1160, 1160,
      1160, 1160, 1160, 1160, 1160, 1160, 1220, 1040, 940, 840, 740, 640, 540,
      440, 340, 240, 120, 100, 100, 100, 100, 100, 100, 100, 100, 100,
    ],
    y: [
      120, 100, 100, 100, 100, 100, 100, 100, 100, 100, 40, 220, 320, 420, 520,
      620, 720, 820, 920, 1020, 1140, 1160, 1160, 1160, 1160, 1160, 1160, 1160,
      1160, 1160, 1220, 1040, 940, 840, 740, 640, 540, 440, 340, 240,
    ],
  },
  target3: {
    x: [
      120, 240, 340, 440, 540, 640, 740, 840, 940, 1040, 1220, 1200, 1200, 1200,
      1200, 1200, 1200, 1200, 1200, 1200, 1140, 1020, 920, 820, 720, 620, 520,
      420, 320, 220, 40, 60, 60, 60, 60, 60, 60, 60, 60, 60,
    ],
    y: [
      40, 60, 60, 60, 60, 60, 60, 60, 60, 60, 120, 240, 340, 440, 540, 640, 740,
      840, 940, 1040, 1220, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
      1200, 1140, 1020, 920, 820, 720, 620, 520, 420, 320, 220,
    ],
  },
  target4: {
    x: [
      40, 220, 320, 420, 520, 620, 720, 820, 920, 1020, 1220, 1240, 1240, 1240,
      1240, 1240, 1240, 1240, 1240, 1240, 1220, 1040, 940, 840, 740, 640, 540,
      440, 340, 240, 40, 20, 20, 20, 20, 20, 20, 20, 20, 20,
    ],
    y: [
      40, 20, 20, 20, 20, 20, 20, 20, 20, 20, 40, 220, 320, 420, 520, 620, 720,
      820, 920, 1020, 1220, 1240, 1240, 1240, 1240, 1240, 1240, 1240, 1240,
      1240, 1220, 1040, 940, 840, 740, 640, 540, 440, 340, 240,
    ],
  },
};
const targetX = (player, box) => {
  return positions[player].x[box];
};
const targetY = (player, box) => {
  return positions[player].y[box];
};
module.exports = {
  targetX,
  targetY,
};
